import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Section = styled.section`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding-top: ${space[5]};
  padding-bottom: ${space[9]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: ${space[10]};
  }
`;

export const PageSection = styled.section`
  width: 100%;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: ${space[5]} ${space[5]};
  overflow: hidden;
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[6]} ${space[8]};
  }

  h2 {
    font-family: ${fonts.heading};
    font-size: ${fonts.size.lg};
    color: ${colors.sectionTitle};
    margin: 0 0 ${space[4]};
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
`;

export const TitleRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: ${space[6]};
  gap: ${space[3]};
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: auto 1fr;
    align-items: start;
  }
`;

export const Title = styled.h2`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
  margin: 0;
  line-height: 1.3;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['2xl']};
  }
`;
